import { Utils } from '../helper/utils';
import { userBALService } from './user.bal';
const {config} = require('../config');
const getColumnList = async (params) => {
    return  {
        'columnSpecs': [
            {displayIndex: 1, 'display': 'Task Detail Id', 'col': 'id','ag-grid': true, hide:true, width: 200 },
            {displayIndex: 2, 'display': 'Item', 'col': 'name','ag-grid': true, width: 200 },
            {displayIndex: 3, 'display': 'Soft Deadline Months', 'col': 'softDeadlineMonths','ag-grid': true, width: 200 },
            {displayIndex: 4, 'display': 'Soft Deadline Days', 'col': 'softDeadlineDays','ag-grid': true, width: 200 },
            {displayIndex: 5, 'display': 'Hard Deadline Months', 'col': 'hardDeadlineMonths','ag-grid': true, width: 200 },
            {displayIndex: 6, 'display': 'Hard Deadline Days', 'col': 'hardDeadlineDays','ag-grid': true, width: 200 },
            {displayIndex: 7, 'display': 'Entity', 'col': 'entity','ag-grid': true, width: 200 },
            {displayIndex: 6, 'display': 'Jurisdiction / Regulator', 'col': 'jurisdictionRegulator','ag-grid': true, width: 200 },
            {displayIndex: 7, 'display': 'Frequency', 'col': 'frequency','ag-grid': true, width: 200 },
            {displayIndex: 8, 'display': 'External Service Provider Involved, If Any', 'col': 'externalServiceProvider','ag-grid': true, width: 200 },
            {displayIndex: 9, 'display': 'Contact Of Service Provider', 'col': 'externalContactName','ag-grid': true, width: 200 },
            {displayIndex: 10, 'display': 'Primary Person', 'col': 'primaryPerson','ag-grid': true, width: 200 },
            {displayIndex: 11, 'display': 'Secondary Person', 'col': 'secondaryPerson','ag-grid': true, width: 200 },
            {displayIndex: 12, 'display': 'Tertiary Person', 'col': 'tertiaryPerson','ag-grid': true, width: 200 },
            {displayIndex: 13, 'display': 'Link', 'col': 'link','ag-grid': true, width: 200 },
            {displayIndex: 14, 'display': 'Remark', 'col': 'remarkMaster','ag-grid': true, width: 200 },
            {displayIndex: 15, 'display': 'End Date', 'col': 'endDate','ag-grid': true, width: 200, 'format': 'dateFormat' },
            {displayIndex: 16, 'display': 'Has Soft Deadline', 'col': 'hasSoftDeadline','ag-grid': true, width: 200 },
            {displayIndex: 17, 'display': 'Last Updated By', 'col': 'lastUpdatedBy','ag-grid': true, width: 200 },
            {displayIndex: 18, 'display': 'Entity Id', 'col': 'entityId','ag-grid': true, hide:true, width: 200 },
            {displayIndex: 19, 'display': 'Jurisdiction Id', 'col': 'jurisdictionId','ag-grid': true, hide:true, width: 200 },
            {displayIndex: 20, 'display': 'Frequency Id', 'col': 'frequencyId','ag-grid': true, hide:true, width: 200 },
            {displayIndex: 21, 'display': 'External Id', 'col': 'externalId','ag-grid': true, hide:true, width: 200 },
            {displayIndex: 22, 'display': 'Primary User Id', 'col': 'primaryUserId','ag-grid': true, hide:true, width: 200 },
            {displayIndex: 23, 'display': 'Secondary User Id', 'col': 'secondaryUserId','ag-grid': true, hide:true, width: 200 },
            {displayIndex: 24, 'display': 'Tertiary User Id', 'col': 'tertiaryUserId','ag-grid': true, hide:true, width: 200 },
            {displayIndex: 25, 'display': 'Last Updated By Id', 'col': 'lastUpdatedById','ag-grid': true, hide:true, width: 200 },
        ]};
}

export const taskDetailBALService = {
    getColumnList,
    getRowData,
    getAutoGroupColumnDef,
    save
};

function getAutoGroupColumnDef(params) {
    return {
        headerName: 'Group',
        field: 'name',
        width: 600,
        pinned: 'left',
      };    
}

function getRowData(params) {
    const requestOptions = { method: 'GET', headers: userBALService.getAuthHeader() };
    return fetch(`${config.apiDDSUrl}/taskDetail/getAll`, requestOptions).then(Utils.handleResponse);
}

function save(row) {
    //row = Utils.removeBlanksNotZero(row);
    return fetch(`${config.apiDDSUrl}/addTaskDetail`, { body: JSON.stringify(row), method: 'PUT', headers: { ...userBALService.getAuthHeader(), 'Content-Type': 'application/json' } }).then( data => { return Utils.handleResponse(data) });
}
